import styled from 'styled-components';
import { Box } from '../common';

const CalendarContainer = styled(Box)`
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.1),
    0px 3px 6px 0px rgba(0, 0, 0, 0.1);
`;

CalendarContainer.defaultProps = {
  borderRadius: 4
};

export default CalendarContainer;
